import { render, staticRenderFns } from "./DatasetCreate.vue?vue&type=template&id=77420db5&scoped=true&"
import script from "./DatasetCreate.vue?vue&type=script&lang=js&"
export * from "./DatasetCreate.vue?vue&type=script&lang=js&"
import style0 from "./DatasetCreate.vue?vue&type=style&index=0&id=77420db5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77420db5",
  null
  
)

export default component.exports